import { Pipe, PipeTransform } from '@angular/core';
import { EIconPath } from '../../project/shared/enums/icons.enum';
import { EStatus } from '../../project/shared/enums/status.enum';
import { statusToImage } from '../../project/shared/status-to-image';

@Pipe({
  name: 'ppStatusImage',
  standalone: false,
})
export class StatusImagePipe implements PipeTransform {
  transform(status: string | undefined, white: boolean): EIconPath {
    if (!status) {
      return null;
    }

    return statusToImage(status as EStatus, white);
  }
}
